import axios from 'axios';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const BASE = `${BACKEND}/api`;

const TOKEN_KEY = 'edu_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY);

const client = axios.create({ baseURL: BASE });
client.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const api = {
  // Auth
  register: (data) => client.post('/auth/register', data).then(r => r.data),
  login: (data) => client.post('/auth/login', data).then(r => r.data),
  me: () => client.get('/auth/me').then(r => r.data),

  // Public
  categories: () => client.get('/categories').then(r => r.data),
  courses: (params = {}) => client.get('/courses', { params }).then(r => r.data),
  course: (id) => client.get(`/courses/${id}`).then(r => r.data),
  testimonials: () => client.get('/testimonials').then(r => r.data),
  settings: () => client.get('/settings').then(r => r.data),
  paymentSettings: () => client.get('/payment/settings').then(r => r.data),
  contact: (data) => client.post('/contact', data).then(r => r.data),
  dod8140Mappings: () => client.get('/dod8140/mappings').then(r => r.data),
  dod8140Lead: (data) => client.post('/dod8140/leads', data).then(r => r.data),
  applyCoupon: (code, subtotal) => client.post('/coupons/apply', { code, subtotal }).then(r => r.data),

  // Auth-required
  enroll: (course_id) => client.post('/enroll', { course_id }).then(r => r.data),
  myEnrollments: () => client.get('/me/enrollments').then(r => r.data),
  checkout: (course_ids, coupon) => client.post('/cart/checkout', { course_ids, coupon }).then(r => r.data),

  // Admin
  admin: {
    stats: () => client.get('/admin/stats').then(r => r.data),

    courseCreate: (d) => client.post('/admin/courses', d).then(r => r.data),
    courseUpdate: (id, d) => client.patch(`/admin/courses/${id}`, d).then(r => r.data),
    courseDelete: (id) => client.delete(`/admin/courses/${id}`).then(r => r.data),

    categoryCreate: (d) => client.post('/admin/categories', d).then(r => r.data),
    categoryUpdate: (id, d) => client.patch(`/admin/categories/${id}`, d).then(r => r.data),
    categoryDelete: (id) => client.delete(`/admin/categories/${id}`).then(r => r.data),

    vouchers: () => client.get('/admin/vouchers').then(r => r.data),
    voucherCreate: (d) => client.post('/admin/vouchers', d).then(r => r.data),
    voucherUpdate: (id, d) => client.patch(`/admin/vouchers/${id}`, d).then(r => r.data),
    voucherDelete: (id) => client.delete(`/admin/vouchers/${id}`).then(r => r.data),

    testimonialCreate: (d) => client.post('/admin/testimonials', d).then(r => r.data),
    testimonialUpdate: (id, d) => client.patch(`/admin/testimonials/${id}`, d).then(r => r.data),
    testimonialDelete: (id) => client.delete(`/admin/testimonials/${id}`).then(r => r.data),

    users: () => client.get('/admin/users').then(r => r.data),
    enrollments: () => client.get('/admin/enrollments').then(r => r.data),
    contacts: () => client.get('/admin/contact').then(r => r.data),
    contactDelete: (id) => client.delete(`/admin/contact/${id}`).then(r => r.data),

    admins: () => client.get('/admin/admins').then(r => r.data),
    adminCreate: (d) => client.post('/admin/admins', d).then(r => r.data),
    adminUpdate: (id, d) => client.patch(`/admin/admins/${id}`, d).then(r => r.data),
    adminResetPassword: (id, password) => client.patch(`/admin/admins/${id}/password`, { password }).then(r => r.data),
    adminDelete: (id) => client.delete(`/admin/admins/${id}`).then(r => r.data),

    settingsUpdate: (d) => client.patch('/admin/settings', d).then(r => r.data),
    paymentGet: () => client.get('/admin/payment/settings').then(r => r.data),
    paymentUpdate: (d) => client.patch('/admin/payment/settings', d).then(r => r.data),

    smtpGet: () => client.get('/admin/smtp').then(r => r.data),
    smtpUpdate: (d) => client.patch('/admin/smtp', d).then(r => r.data),
    smtpTest: (to) => client.post('/admin/smtp/test', { to }).then(r => r.data),

    llmGet: () => client.get('/admin/llm').then(r => r.data),
    llmUpdate: (d) => client.patch('/admin/llm', d).then(r => r.data),

    dod8140Mappings: () => client.get('/admin/dod8140/mappings').then(r => r.data),
    dod8140MappingCreate: (d) => client.post('/admin/dod8140/mappings', d).then(r => r.data),
    dod8140MappingUpdate: (id, d) => client.patch(`/admin/dod8140/mappings/${id}`, d).then(r => r.data),
    dod8140MappingDelete: (id) => client.delete(`/admin/dod8140/mappings/${id}`).then(r => r.data),
    dod8140Leads: () => client.get('/admin/dod8140/leads').then(r => r.data),
  },

  llmConfig: () => client.get('/llm/config').then(r => r.data),
  chatSend: (data) => client.post('/chat', data).then(r => r.data),
};
